module.exports = __webpack_public_path__ + "static/img/apply_banner_03.86812f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/apply_banner_03.png
// module id = C5GK
// module chunks = 34